/*
  Motureo: interakcje sekcji stron (W2, etap 8), bez bibliotek.
  „Części według marki auta” (sections/motureo-car-makes.liquid z włączonym wyborem modelu): kliknięcie
  marki pokazuje pod siatką modele tej marki z assets/motureo-auta.json (dane katalogu BG, te same adresy
  wyszukiwania co selektor pojazdu). Bez skryptu kafel marki prowadzi do wyszukiwania po marce.
*/
(() => {
  'use strict';

  if (window.motureoStrony) return;
  window.motureoStrony = true;

  let dataPromise = null;
  const loadData = (url) => {
    if (!dataPromise) {
      dataPromise = fetch(url, { credentials: 'omit' })
        .then((r) => (r.ok ? r.json() : Promise.reject(new Error(String(r.status)))))
        .catch((error) => {
          dataPromise = null;
          throw error;
        });
    }
    return dataPromise;
  };

  const searchHref = (base, query) => {
    const params = new URLSearchParams({ q: query, type: 'product' });
    params.set('options[prefix]', 'last');
    params.set('options[unavailable_products]', 'last');
    return `${base}?${params.toString()}`;
  };

  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  };

  const initMakes = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const panel = root.querySelector('[data-makes-panel]');
    if (!panel) return;
    const links = Array.from(root.querySelectorAll('[data-make-query]'));
    const searchUrl = root.dataset.searchUrl || '/search';
    const bg = (document.documentElement.lang || '').toLowerCase().startsWith('bg');
    let current = null;

    // Z JavaScriptem kafel marki działa jak przycisk (otwiera panel modeli), więc ma rolę przycisku i reaguje
    // też na spację; bez JavaScriptu zostaje zwykłym odnośnikiem do wyszukiwania (przegląd D6)
    links.forEach((link) => {
      link.setAttribute('role', 'button');
      link.setAttribute('aria-controls', panel.id);
      link.setAttribute('aria-expanded', 'false');
      link.addEventListener('keydown', (event) => {
        if (event.key === ' ') {
          event.preventDefault();
          link.click();
        }
      });
    });

    const close = () => {
      panel.hidden = true;
      panel.replaceChildren();
      if (current) current.setAttribute('aria-expanded', 'false');
      current = null;
    };

    const render = (link, make) => {
      const name = link.dataset.makeName || link.textContent.trim();
      const heading = el('p', 'motureo-makes__panel-heading', (root.dataset.modelsHeading || '').replace('[make]', name));
      const all = el('a', 'motureo-w2-sec__link', `${(root.dataset.allLabel || '').replace('[make]', name)} →`);
      all.href = link.href;
      const closeButton = el('button', 'motureo-makes__panel-close');
      closeButton.type = 'button';
      closeButton.setAttribute('aria-label', root.dataset.closeLabel || '');
      closeButton.textContent = '×';
      closeButton.addEventListener('click', () => {
        const back = current;
        close();
        back?.focus();
      });
      const top = el('div', 'motureo-makes__panel-top');
      top.append(heading, closeButton);
      const list = el('ul', 'motureo-makes__models');
      list.setAttribute('role', 'list');
      (make?.models || []).forEach((model) => {
        const item = el('li');
        const a = el('a', '', bg && model.bg ? model.bg : `${make.name} ${model.name}`);
        a.href = model.url || searchHref(searchUrl, model.q);
        item.append(a);
        list.append(item);
      });
      panel.replaceChildren(top, list, all);
      panel.hidden = false;
      panel.focus({ preventScroll: true });
      panel.scrollIntoView({ block: 'nearest', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };

    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
        event.preventDefault();
        if (current === link) {
          close();
          return;
        }
        if (current) current.setAttribute('aria-expanded', 'false');
        current = link;
        link.setAttribute('aria-expanded', 'true');
        loadData(root.dataset.dataUrl)
          .then((data) => {
            const query = (link.dataset.makeQuery || '').toLowerCase();
            const make = (data.makes || []).find((m) => String(m.q).toLowerCase() === query);
            // marka bez modeli w danych: zwykłe przejście do wyszukiwania (nie pokazujemy pustej listy)
            if (!make || !make.models || make.models.length === 0) {
              window.location.assign(link.href);
              return;
            }
            if (current === link) render(link, make);
          })
          .catch(() => window.location.assign(link.href));
      });
    });

    panel.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        const back = current;
        close();
        back?.focus();
      }
    });
  };

  const init = () => document.querySelectorAll('[data-motureo-makes]').forEach(initMakes);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
